import {
  WorkInjuryAcceptedCoverageType,
  WorkInjuryEmployerLiabilityBundle
} from "@wingspanhq/benefits/dist/src/lib/interfaces/insuranceRequirement";
import {
  RequirementDefinitionTransitionScope,
  RequirementDefinitionTransitionStrategy
} from "@wingspanhq/wingspan-api-sdk";

import { FlowCreateNewVersionTransitionData } from "../../types";

export const DEFAULT_RENEWAL_DEADLINE_DAYS = 30;

export const DEFAULT_TRANSITION_DATA: FlowCreateNewVersionTransitionData = {
  renewalDeadlineDays: DEFAULT_RENEWAL_DEADLINE_DAYS,
  scope: RequirementDefinitionTransitionScope.ALL,
  transitionMethod: RequirementDefinitionTransitionStrategy.RENEWAL
};

export const WORKERS_COMP_BUNDLE_LABELS: Record<string, string> = {
  [WorkInjuryEmployerLiabilityBundle.FiveHundredFiveHundredFiveHundred]:
    "$500k / $500k / $500k",
  [WorkInjuryEmployerLiabilityBundle.OneHundredFiveHundredOneHundred]:
    "$100k / $500k / $100k",
  [WorkInjuryEmployerLiabilityBundle.OneMillionBundle]: "$1M / $1M / $1M"
};

export const COVERAGE_TYPE_LABELS: Record<string, string> = {
  [WorkInjuryAcceptedCoverageType.Either]:
    "Workers' Comp or Occupational Accident",
  [WorkInjuryAcceptedCoverageType.OccupationalAccident]:
    "Occupational Accident only",
  [WorkInjuryAcceptedCoverageType.WorkersCompensation]:
    "Workers' Compensation only"
};
